<div class="bottom-sheet-content" #gestureArea>
  <div class="sheet-header">
    <div class="handle-bar"></div>
    <div class="back-button" (click)="cancel()" (keydown)="cancel()" tabindex="0">
      <img src="assets/ic-close.svg" alt="cancel icon" />
    </div>
  </div>

  <div class="title section-title-container">
    <h2>Switch Business</h2>
    <ion-note>Select which business to manage</ion-note>
  </div>

  <div class="business-list">
    <ion-list lines="none">
      <ion-item 
        *ngFor="let business of permittedBusinesses" 
        button 
        (click)="selectBusiness(business)"
        [disabled]="isSwitching"
        [class.selected]="business.id === currentBusinessId"
      >
        <div class="business-item">
          <div class="image-wrapper square small">
            <ion-skeleton-text animated *ngIf="!imageLoadedMap[business.id] && business.avatarUrl"></ion-skeleton-text>
            <ion-img 
              [alt]="business.name + ' logo'" 
              [src]="business.avatarUrl || 'assets/ic-business.svg'"
              (ionImgDidLoad)="onImageLoad(business.id)"
              [class.hidden]="!imageLoadedMap[business.id] && business.avatarUrl"
              [class.fade-in]="business.avatarUrl"
            ></ion-img>
          </div>
          <div class="business-info">
            <ion-label>
              <h3>{{ business.name }}</h3>
              <p *ngIf="business.city && business.state">{{ business.city }}, {{ business.state }}</p>
            </ion-label>
          </div>
          <ion-icon 
            *ngIf="business.id === currentBusinessId" 
            name="checkmark-circle" 
            color="primary"
            class="selected-icon"
          ></ion-icon>
        </div>
      </ion-item>
    </ion-list>
  </div>

  <div class="action-footer" *ngIf="isSwitching">
    <ion-spinner name="crescent"></ion-spinner>
    <ion-text color="medium">Switching business...</ion-text>
  </div>
</div>

